module.exports = __webpack_public_path__ + "assets/celebration-bba4e9.svg";